const e = ({ event: t, payload: d }) => {
  const a = window;
  a.dataLayer = a.dataLayer || [], a.dataLayer.push({ event: t, ...d });
};
export {
  e as addEventToDataLayer
};
